import React, { Component } from 'react';
import { InventoryBasicSetup } from '../inventorybasicsetup/InventoryBasicSetup';

class AccountCategorySetup extends Component {
  render() {
    return (
      <InventoryBasicSetup
        resourceName={'InvGroup/AccountCategory'}
        humanName={'Account Category'}
        {...this.props}
      />
    );
  }
}

export { AccountCategorySetup };



// WEBPACK FOOTER //
// ./src/pages/inventory/accountcategorysetup/AccountCategorySetup.js